import axios from "axios";

import { apiUrl } from "@/utils/helpers";
import { GetCohortDetailsResponse } from "./get-cohort-details.types";

const path = "/api/course/v2/fetch_course/ref_no_auth";

export const getCohortDetails = async (
  id: string,
  localizationCode?: string
) => {
  console.log("Calling Rigi_backend with payload: ", {
    refCode: id,
    isdCode: localizationCode,
  });
  const { data } = await axios.post(apiUrl(path), {
    refCode: id,
    isdCode: localizationCode,
  });

  return data as GetCohortDetailsResponse;
};

export const GET_COHORT_DETAILS_KEY = `GET_COHORT_DETAILS`;
